<template>
  <div class="new-main">
    <div class="centerWidth new-w2 d-flex">
      <div class="swiper_wrap">
        <el-carousel height="400px" :interval="8000">
          <el-carousel-item v-for="(item,index) in piclist" :key="index">
            <div class="new-item">
              <img :src="item.image" @click="toDetails(2,item)"/>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="right-con">
        <div class="d-flex d-just-between d-align-center tit-wrap">
          <div class="d-flex">
            <div class="tit" :class="cur == 0?'cur':''" @click="toNav(0)">通知公告</div>
            <div class="tit" :class="cur == 1?'cur':''" @click="toNav(1)">政策新闻</div>
          </div>
          <div class="more" v-if="cur == 0" @click="toMore(0)">更多&gt;</div>
          <div class="more" v-if="cur == 1" @click="toMore(1)">更多&gt;</div>
        </div>
        <div class="news-tab">
          <div class="news-item">
            <ul class="news-list1" v-if="cur == 0">
              <li class="d-flex d-just-between d-align-center" v-for="(item,index) in gonggao" :key="index"
                  @click="toDetails(1,item)">
                <div class="tit1 d-flex d-align-center">
                  <span></span>
                  <span>{{ item.title }}</span>
                </div>
                <div class="date">{{ item.create_time.split(' ')[0] }}</div>
              </li>
            </ul>
            <ul class="news-list1" v-if="cur == 1">
              <li class="d-flex d-just-between d-align-center" v-for="(item,index) in zhengce" :key="index"
                  @click="toDetails(2,item)">
                <div class="tit1 d-flex d-align-center">
                  <span></span>
                  <span>{{ item.title }}</span>
                </div>
                <div class="date">{{ item.create_time.split(' ')[0] }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="centerWidth new-w10">
      <div class="new-tit2 new-tit i-tit4">
        <a class="tit cur">便捷工具</a>
      </div>
      <div class="new-bar3 d-flex d-just-between">
        <div class="item" @click="toPageLogin('/login?type=1',1)">
          <img src="../assets/images/bianjie1.png"/>
          <p>在线学习系统</p>
        </div>
        <div class="item" @click="toPageLogin('/login?type=2',2)">
          <img src="../assets/images/bianjie2.png"/>
          <p>在线考试系统</p>
        </div>
        <div class="item" @click="toPageLogin('/login?type=3',3)">
          <img src="../assets/images/bianjie3.png"/>
          <p>在线查询系统</p>
        </div>
        <div class="item" @click="toPageLogin('/courseList')">
          <img src="../assets/images/bianjie4.png"/>
          <p>课程查询系统</p>
        </div>
        <div class="item" @click="toPageLogin('/feature')">
          <img src="../assets/images/bianjie5.png"/>
          <p>特色专区系统</p>
        </div>
        <div class="item" @click="toPageLogin('/support')">
          <img src="../assets/images/bianjie6.png"/>
          <p>技术支持系统</p>
        </div>
      </div>
    </div>
    <!--    <div class="centerWidth new-bar1">-->
    <!--      <a class="" href="https://rlsbj.cq.gov.cn/ztzl/zqs2020ndkslygwyzl/"-->
    <!--         target="_blank"><img src="../assets/images/yx.png"/>-->
    <!--      </a>-->
    <!--    </div>-->
    <div class="new-w3">
      <div class="centerWidth new-w3-wrap">
        <div class="new-tit1">
          <a class="tit">
            <p class="ch">覆盖领域</p>
            <p class="ch1">50+行业技术领域课程</p>
          </a>
        </div>
        <div class="zwgk-bar">
          <div class="item" v-for="(item,index) in lingyu" :key="index" @click="toJump(item.url)">
            <div class="icon">
              <img :src="item.img">
              <img class="cur" :src="item.img1">
            </div>
            <span>{{ item.title }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="new-w8 centerWidth">
      <div class="new-w8box rt new-sw">
        <div class="new-tit2 new-tit d-flex d-just-between d-align-center">
          <div class="tit cur">公开课程</div>
          <div class="more" @click="toMore(2)">更多&gt;</div>
        </div>
        <div class="new-tab d-flex">
          <div class="swiper_wrap">
            <el-carousel height="360px" :interval="6000">
              <el-carousel-item v-for="(item,index) in pickecheng1" :key="index">
                <div class="new-item">
                  <img :src="item.image" @click="toDetails(3,item)"/>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="right-con">
            <div class="news-tab">
              <div class="news-item">
                <ul class="news-list1">
                  <li class="d-flex d-just-between d-align-center" v-for="(item,index) in pickecheng" :key="index"
                      @click="toDetails(3,item)">
                    <div class="tit1 d-flex d-align-center">
                      <span></span>
                      <span>{{ item.title }}</span>
                    </div>
                    <div class="date">{{ item.create_time.split(' ')[0] }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="new-w9 centerWidth">
      <div class="new-tit2 new-tit d-flex d-just-between d-align-center">
        <div class="tit cur">推荐课程</div>
        <div class="more" @click="toPage('/courseList')">更多&gt;</div>
      </div>
      <div class="kecheng_wrap kecheng_wrap_1 d-flex">
        <div class="item" v-for="(item,index) in course" :key="index" @click="toKc(item.url)" :style="{backgroundImage:`url(${item.bg})`}">
          <div class="top">
            <div>{{ item.name }}</div>
            <div>{{ item.type == 1 ? '视频学习+题库学习' : item.type == 2 ? '视频学习' : '题库学习' }}</div>
            <div>{{ item.studytime }}学时</div>
          </div>
          <div class="bottom">智慧数字化赋能教育考培服务平台</div>
        </div>
      </div>
    </div>
    <div class="new-w11 centerWidth">
      <div class="new-tit2 new-tit d-flex d-just-between d-align-center">
        <div class="tit cur">精选书籍</div>
<!--        <div class="more" @click="toPage('/courseList')">更多&gt;</div>-->
      </div>
      <div class="bookrec-box">
        <div class="bookrec-item" v-if="books.length">
          <a :href="item.url" target="_blank" v-for="(item,index) in books" :key="index">
            <img :src="item.img">
            <span>{{item.name}}</span>
          </a>
        </div>
        <div class="bookrec-item" v-if="books1.length">
          <a :href="item.url" target="_blank" v-for="(item,index) in books1" :key="index">
            <img :src="item.img">
            <span>{{item.name}}</span>
          </a>
        </div>
      </div>
    </div>
    <div class="new-w10 centerWidth">
      <div class="new-tit2 new-tit d-flex d-just-between d-align-center">
        <div class="tit cur">友情链接</div>
      </div>
      <div class="yqlj">
          <span v-for="(item,index) in link" :key="index">
              <a :href="item.url" :title="item.title" target="_blank">
                  {{ item.title }}
              </a>
          </span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  indexInfo,
  get_book_lists
} from "@/api/index";

export default {
  name: 'Home',
  components: {},
  data() {
    return {
      cur: 0,
      piclist: [],
      gonggao: [],
      zhengce: [],
      pickecheng: [],
      pickecheng1: [],
      lingyu: [],
      link: [],
      course: [],
      books: [],
      books1: [],
    };
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      indexInfo().then(res => {
        console.log(res)
        if (res.code == 1) {
          this.piclist = res.data.piclist.splice(0, 4)
          this.gonggao = res.data.gonggao
          this.zhengce = res.data.zhengce
          this.lingyu = res.data.lingyu

          this.link = res.data.link
          this.pickecheng = res.data.kecheng
          this.pickecheng1 = res.data.pickecheng.splice(0, 4)
          this.course = res.data.course.splice(0, 6)
          let list = JSON.parse(JSON.stringify(res.data.book.slice(0,10)))
          this.books = list.splice(0, 5)
          this.books1 = list
          for (let i in this.course) {
            if (i == 0 || i == 1 || i == 2) {
              this.course[i].bg = localStorage.getItem('first_bg')?localStorage.getItem('first_bg'):'../assets/images/kc_bg1.png'
            }else {
              this.course[i].bg = localStorage.getItem('second_bg')?localStorage.getItem('second_bg'):'../assets/images/kc_bg2.png'
            }
          }
        }
      })
    },
    toDetails(num, item) {
      if (item.url) {
        window.open(item.url)
      }else{
        this.$router.push({
          path: 'detail',
          query: {
            id: item.id,
            type: num
          }
        })
      }
    },
    guanyu() {
      this.$router.push({
        path: 'About'
      })
    },
    toNav(index) {
      this.cur = index
    },
    toPage(url) {
      this.$router.push({
        path: url,
      })
    },
    toPageLogin(url,num) {
      let token = localStorage.getItem('token')
      if (url.includes('login')) {
        if ( !token ) {
          this.$router.push({
            path: url,
          })
        }else {
          if (num == 1) {
            this.$router.push({
              path: '/myCourseList',
            })
          }else if (num == 2) {
            this.$router.push({
              path: '/examList',
            })
          }else if (num == 3) {
            this.$router.push({
              path: '/login?type=3',
            })
          }
        }
      }else{
        this.$router.push({
          path: url,
        })
      }
    },
    toMore(num) {
      if (num == 0) {
        this.$router.push({
          path: '/announcement',
        })
      } else if (num == 1) {
        this.$router.push({
          path: '/policyNews',
        })
      } else if (num == 2) {
        this.$router.push({
          path: '/publicCourses',
        })
      }
    },
    toJump(url) {
      if (url) {
        window.open(url)
      }
    },
    toKc(url) {
      if (url) {
        window.open(url)
      }
    }
  }
};
</script>

<style scoped lang="scss">
.new-w2 {
  padding-top: 30px;

  .swiper_wrap {
    width: 570px;

    .new-item {
      width: 100%;
      height: 100%;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 8px;
      }
    }
  }

  .right-con {
    margin-left: 30px;
    width: 600px;

    .tit-wrap {
      border-bottom: 1px solid #dbe4f2;
    }

    .more {
      cursor: pointer;
      color: #333;
    }

    .tit {
      height: 42px;
      line-height: 39px;
      min-width: auto;
      padding: 0 18px;
      color: #333333;
      font-size: 18px;
      cursor: pointer;
    }

    .tit.cur {
      font-size: 18px;
      font-weight: bold;
      border-bottom: 3px solid #be0d0d;
      background: #2257ab;
      color: #fff;
    }

    .news-tab {
      .news-list1 {
        height: 45px;
        line-height: 45px;

        .tit1 {
          max-width: 80%;
          cursor: pointer;

          span:nth-child(1) {
            width: 5px;
            height: 5px;
            background: #2257ab;
            border-radius: 50%;
            margin-right: 10px;
          }

          span:nth-child(2) {
            flex: 1;
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: #333;
            font-size: 16px;

            &:hover {
              color: #2257ab;
            }
          }
        }

        .date {
          color: #a5a5a5;
          font-size: 16px;
        }
      }
    }
  }
}

.new-w3 {
  margin-top: 30px;
  position: relative;
  background: #F1F7FF;

  .new-w3-wrap {
    padding: 30px 0 10px 0;
    text-align: center;
  }

  .zwgk-bar {
    padding-top: 30px;
    background: url(../assets/images/fw_bg.png) center center / 100% no-repeat;
    min-height: 310px;
    display: flex;
    flex-wrap: wrap;

    .item {
      display: flex;
      width: 220px;
      height: 64px;
      line-height: 64px;
      background: #fff;
      box-shadow: 0 0 10px 0 rgba(81, 94, 129, .18);
      border-radius: 4px;
      margin: 0 25px 28px 0;
      cursor: pointer;

      &:hover {
        background: #1f58ae;
        border-bottom: 5px solid #be0d0d;
        box-shadow: none;

        span {
          color: #fff;
        }

        div {
          height: 59px;
          border-right: 1px solid #88a7d4;

          img {
            display: none;
          }

          img.cur {
            display: inline-block;
          }
        }
      }

      &:nth-child(5n) {
        margin-right: 0;
      }

      .icon {
        width: 60px;
        border-right: 1px solid #e2e9f1;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 30px;
          height: 30px;
        }

        img.cur {
          display: none;
        }
      }

      span {
        width: 160px;
        color: #333333;
        font-size: 18px;
        vertical-align: middle;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}

.new-bar1 {
  margin-top: 30px;
  position: relative;
  overflow: hidden;
  height: 100px;

  a {
    display: block;
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }
}


.new-main {
  padding-bottom: 30px;
}

.new-main * {
  box-sizing: border-box;
}

.new-bar3 {
  margin-top: 30px;

  .item {
    display: inline-block;
    background: #fff;
    //box-shadow: 0 0 10px 0 rgba(185, 185, 185, .43);
    text-align: center;
    position: relative;
    cursor: pointer;

    &:nth-child(6n) {
      margin-right: 0;
    }

    img {
      width: 100px;
      height: 100px;
      margin-bottom: 16px;
      transition: transform 0.3s ease;
    }

    img:hover {
      transform: scale(1.2);
    }

    img.cur {
      display: none;
    }

    p {
      color: #333333;
      font-size: 20px;
      font-family: 'Avenir', Helvetica, Arial, sans-serif;
      font-weight: bold;
    }
  }
}

.new-w8 {
  margin-top: 30px;
}

.new-w8box {
  width: 100%;

  .new-tab {
    margin-top: 30px;

    /deep/ .el-carousel__button {
      width: 10px;
      height: 10px;
      border-radius: 50%;
    }

    /deep/ .el-carousel__indicators--horizontal {
      left: 85%;
    }

    /deep/ .is-active .el-carousel__button {
      background: #2257ab;
    }

    .swiper_wrap {
      width: 570px;

      .new-item {
        width: 100%;
        height: 100%;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 8px;
        }
      }
    }

    .right-con {
      margin-left: 30px;
      width: 600px;

      .news-tab {
        .news-list1 {
          height: 45px;
          line-height: 45px;

          .tit1 {
            max-width: 80%;
            cursor: pointer;

            span:nth-child(1) {
              width: 5px;
              height: 5px;
              background: #2257ab;
              border-radius: 50%;
              margin-right: 10px;
            }

            span:nth-child(2) {
              flex: 1;
              display: inline-block;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              color: #333;
              font-size: 16px;

              &:hover {
                color: #2257ab;
              }
            }
          }

          .date {
            color: #a5a5a5;
            font-size: 16px;
          }
        }
      }
    }
  }
}

.new-w9 {
  margin-top: 30px;

  .kecheng_wrap {
    display: flex;
    flex-wrap: wrap;
    margin-top: 30px;

    .item {
      cursor: pointer;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      height: 225px;
      width: 380px;
      margin-right: 30px;
      position: relative;

      &:nth-child(3n) {
        margin-right: 0;
      }

      &:nth-child(1), &:nth-child(2), &:nth-child(3) {
        margin-bottom: 20px;
      }

      .top {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        color: #ffffff;
        height: 200px;

        div:nth-child(2) {
          margin: 5px 0;
        }
      }

      .bottom {
        font-size: 10px;
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 25px;
        line-height: 25px;
        color: #fff;
        text-align: center;
      }
    }
  }

  .kecheng_wrap_1 {
    .item {
      background-image: url("../assets/images/kc_bg1.png");
    }
  }

  .kecheng_wrap_2 {
    .item {
      background-image: url("../assets/images/kc_bg2.png");
    }
  }
}
.new-w11 {
  margin-top: 30px;

  .bookrec-box{
    margin-top: 30px;
    margin-bottom: 70px;
    position: relative;
    width: 100%;
    //overflow: hidden;
    box-sizing: border-box;
    .bookrec-item {
      margin-top: 40px;
      display: flex;
      background: url(../assets/images/bookrec.png) no-repeat bottom center;
      background-size: 100%;

       a {
         height: 200px;
         display: inline-block;
         position: relative;
        width: 140px;
         &:nth-child(1){
           margin-left: 75px;
         }
         &:nth-child(2){
           margin-left: 90px;
         }
         &:nth-child(3){
           margin-left: 90px;
         }
         &:nth-child(4){
           margin-left: 90px;
         }
         &:nth-child(5){
           margin-left: 75px;
         }
         img {
           width: 140px;
           height: 200px;
           object-fit: cover;
           position: relative;
           z-index: 10;
           background-color: white;
           top: -25px;
         }
         span{
           position: absolute;
           z-index: 99;
           width: 140px;
           color: #333333;
           display: inline-block;
           bottom: -55px;
           left: 0;
           height: 50px;
           text-align: center;
         }
      }
    }
  }
}

.new-w10 {
  margin-top: 30px;
  .yqlj{
    display: flex;
    flex-wrap: wrap;
    span{
      width: 170px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &:nth-child(6n){
        margin-right: 0;
      }
    }
  }
}
</style>
